import {
  bulkUpdateStockReplenishmentStatus,
  createForecast,
  createMultipleForecasts,
  createMultipleWarehouseCosting,
  createMultipleWarehouseCostingRange,
  createStockOnHand,
  createWarehouseCosting,
  createWarehouseCostingRange,
  deleteForecasts,
  getDownloadedForecast,
  getDownloadedWarehouseCosting,
  getDownloadedWarehouseCostingRange,
  getForecasts,
  getPicklist,
  getPicklists,
  getPicklistSelection,
  getSites,
  getSitesSelection,
  getStockFields,
  getStockLocations,
  getStockLocationsSelection,
  getStockMethods,
  getStockOnHand,
  getStockPack,
  getStockPacks,
  getStockPacksSelection,
  getStockReplenishments,
  getStockReplenishmentSelection,
  getStockStatus,
  getStockZones,
  getStockZonesSelection,
  getWarehouseCosting,
  getWarehouseCostingFields,
  getWarehouseCostingRange,
  getWarehouseCostingRangeFields,
  getWarehouseInventory,
  getWarehouseLanded,
  getWorkCenters,
  getWorkCentersSelection,
  getWorkCenterTypes,
  setStanadardCosts,
  setStockLines,
  setStockLineStatus,
  updateForecast,
  updateMultipleForecast,
  updateMultipleWarehouseCosting,
  updateMultipleWarehouseCostingRange,
  updateStockOnHand,
  updateWarehouseCosting,
  updateWarehouseCostingRange,
} from "../slice/warehouseSlice";
import { apiSlice } from "./apiSlice";
import { fileResponseHandler } from "./utils";
import { patchWarehouseCostingListCaches } from "./warehouseCostingListCache";

export const warehouseApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createForecast: builder.mutation({
      query: data => ({
        url: "/api_warehouse/forecast/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(createForecast(result.data))).catch(error => {});
      },
    }),
    createStockLine: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_line/",
        method: "post",
        body: data,
      }),
    }),
    createStockLineAdjust: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_line/stock_adjust/",
        method: "post",
        body: data,
      }),
    }),
    createMultipleForecasts: builder.mutation({
      query: data => ({
        url: "/api_warehouse/forecast/create_multiple_forecasts/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleForecasts(result.data.data)))
          .catch(error => {});
      },
    }),

    createMultipleWarehouseCosting: builder.mutation({
      query: data => ({
        url: "/api_warehouse/warehouse_costing/create_multiple_warehouse_costing/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleWarehouseCosting(result.data.data)))
          .catch(error => {});
      },
    }),
    createMultipleWarehouseCostingRange: builder.mutation({
      query: data => ({
        url: "/api_warehouse/warehouse_costing_range/create_multiple_warehouse_costing_range/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleWarehouseCostingRange(result.data.data)))
          .catch(error => {});
      },
    }),
    createStockOnHand: builder.mutation({
      query: data => ({ url: "/api_warehouse/stock/create_stock/", method: "post", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createStockOnHand(result.data.data)))
          .catch(error => {});
      },
    }),
    createStandardCosting: builder.mutation({
      query: data => ({ url: "/api_warehouse/standard_costing/", method: "post", body: data }),
    }),
    createStockZone: builder.mutation({
      query: data => ({ url: "/api_warehouse/stock_zone/", method: "post", body: data }),
      invalidatesTags: ["StockZoneList", "StockZoneSelection", "StockZoneTypes"],
    }),
    createWarehouseCosting: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/warehouse_costing/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "WarehouseCostingList",
        "WarehouseCostingSelection",
        "ProductWarehouseCosting",
      ],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createWarehouseCosting(result.data)))
          .catch(error => {});
      },
    }),
    createWarehouseCostingRange: builder.mutation({
      query: data => ({
        url: "/api_warehouse/warehouse_costing_range/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createWarehouseCostingRange(result.data)))
          .catch(error => {});
      },
    }),
    deleteForecasts: builder.mutation({
      query: data => ({
        url: "/api_warehouse/forecast/delete_forecast/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(deleteForecasts(result.data.data)))
          .catch(error => {});
      },
    }),
    getDownloadedForecast: builder.query({
      query: params =>
        params
          ? `/api_warehouse/forecast/download_records/?${params}`
          : "/api_warehouse/forecast/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedForecast(result.data.data)))
          .catch(error => {});
      },
    }),

    getDownloadedWarehouseCosting: builder.query({
      query: params =>
        params
          ? `/api_warehouse/warehouse_costing/download_records/?${params}`
          : "/api_warehouse/warehouse_costing/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedWarehouseCosting(result.data.data)))
          .catch(error => {});
      },
    }),
    getDownloadedWarehouseCostingRange: builder.query({
      query: params =>
        params
          ? `/api_warehouse/warehouse_costing_range/download_records/?${params}`
          : "/api_warehouse/warehouse_costing_range/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedWarehouseCostingRange(result.data.data)))
          .catch(error => {});
      },
    }),
    getForecasts: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/forecast/?${params}` : "/api_warehouse/forecast/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getForecasts(result.data))).catch(error => {});
      },
    }),

    getForecastById: builder.query({
      query: id => ({
        url: `/api_warehouse/forecast/${id}/`,
      }),
    }),
    getStandardCosts: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/standard_costing/?${params}` : "/api_warehouse/standard_costing/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setStanadardCosts(result.data))).catch(error => {});
      },
    }),

    getStandardCostingById: builder.query({
      query: id => ({
        url: `/api_warehouse/standard_costing/${id}/`,
      }),
    }),
    getStockFields: builder.query({
      query: () => "/api_warehouse/stock_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockFields(result.data))).catch(error => {});
      },
    }),
    getStockLines: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/stock_line/?${params}` : "/api_warehouse/stock_line/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setStockLines(result.data))).catch(error => {});
      },
    }),
    getStockLineStatus: builder.query({
      query: () => "/api_warehouse/stock_line_status/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setStockLineStatus(result.data))).catch(error => {});
      },
    }),
    createStockLocation: builder.mutation({
      query: data => ({ url: "/api_warehouse/stock_location/", method: "post", body: data }),
    }),

    getStockLocations: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/stock_location/?${params}` : "/api_warehouse/stock_location/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockLocations(result.data))).catch(error => {});
      },
    }),
    getStockLocationById: builder.query({
      query: id => ({
        url: `/api_warehouse/stock_location/${id}/`,
      }),
    }),
    getStockLocationsSelection: builder.query({
      query: args => ({
        url: "/api_warehouse/stock_location/selection/",
        params: args?.params,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getStockLocationsSelection(result.data)))
          .catch(error => {});
      },
    }),
    getStockMethods: builder.query({
      query: () => "/api_warehouse/stock_methods/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockMethods(result.data))).catch(error => {});
      },
    }),
    getStockOnHand: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/stock/?${params}` : "/api_warehouse/stock/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockOnHand(result.data))).catch(error => {});
      },
    }),
    getStockStatus: builder.query({
      query: () => "/api_warehouse/stock_status/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockStatus(result.data))).catch(error => {});
      },
    }),
    getStockReplenishment: builder.query({
      query: (params = null) =>
        params
          ? `/api_warehouse/stock_replenishment/?${params}`
          : "/api_warehouse/stock_replenishment/",
      providesTags: ["StockReplenishmentList"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getStockReplenishments(result.data)))
          .catch(error => {});
      },
    }),
    getPicklists: builder.query({
      query: (params = null) =>
        params ? `/api/warehouse/v1/picklist/?${params}` : `/api/warehouse/v1/picklist/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getPicklists(result.data))).catch(error => {});
      },
      providesTags: ["Picklist"],
    }),
    getPicklistSelection: builder.query({
      query: (params = null) =>
        params
          ? `/api/warehouse/v1/picklist/selection/?${params}`
          : `/api/warehouse/v1/picklist/selection/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getPicklistSelection(result.data)))
          .catch(error => {});
      },
    }),
    getPicklistById: builder.query({
      query: id => ({ url: `/api/warehouse/v1/picklist/${id}/` }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getPicklist(result.data))).catch(error => {});
      },
    }),
    downloadPicklistPdf: builder.query({
      query: id => ({
        url: `/api/warehouse/v1/picklist/${id}/download_pdf/`,
        responseHandler: fileResponseHandler,
      }),
    }),
    getPicklistLines: builder.query({
      query: (params = null) =>
        params ? `/api/warehouse/v1/picklist_line/?${params}` : `/api/warehouse/v1/picklist_line/`,
    }),
    getStockReplenishmentSelection: builder.query({
      query: () => "/api_warehouse/stock_replenishment/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getStockReplenishmentSelection(result.data)))
          .catch(error => {});
      },
    }),
    getStockReplenishmentById: builder.query({
      query: id => ({
        url: `/api_warehouse/stock_replenishment/${id}/`,
      }),
    }),
    confirmStockReplenishment: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api_warehouse/stock_replenishment/${id}/confirm/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["StockReplenishmentList"],
    }),
    bulkConfirmReplenishment: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_replenishment/bulk_confirm/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["StockReplenishmentList"],
    }),
    bulkRejectReplenishment: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_replenishment/bulk_reject/",
        method: "POST",
        body: data,
      }),
      onQueryStarted: (data, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(() => {
            dispatch(
              bulkUpdateStockReplenishmentStatus({
                ids: data.ids,
                status: { id: "rejected", name: "Rejected" },
              }),
            );
          })
          .catch(err => {});
      },
    }),
    getStockZones: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/stock_zone/?${params}` : "/api_warehouse/stock_zone/",
      providesTags: ["StockZoneList"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockZones(result.data))).catch(error => {});
      },
    }),
    getStockZoneById: builder.query({
      query: id => ({
        url: `/api_warehouse/stock_zone/${id}/`,
      }),
    }),
    getStockZonesSelection: builder.query({
      query: arg => ({ url: "/api_warehouse/stock_zone/selection/", params: arg?.params }),
      providesTags: ["StockZoneSelection"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getStockZonesSelection(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseStockZoneTypes: builder.query({
      query: (params = null) =>
        params ? `/api_warehouse/stock_zone/types/?${params}` : "/api_warehouse/stock_zone/types/",
      transformResponse: response => (Array.isArray(response) ? response : response?.results || []),
      providesTags: ["StockZoneTypes"],
    }),
    getSitesSelection: builder.query({
      providesTags: ["SiteSelection"],
      query: (params = null) =>
        params
          ? `/api/warehouse/v1/site/selection/?${params}`
          : "/api/warehouse/v1/site/selection/",
      transformResponse: response => (Array.isArray(response) ? response : response?.results || []),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getSitesSelection(result.data))).catch(error => {});
      },
    }),
    getSites: builder.query({
      providesTags: ["SiteList"],
      query: (params = null) =>
        params ? `/api/warehouse/v1/site/?${params}` : "/api/warehouse/v1/site/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getSites(result.data))).catch(error => {});
      },
    }),
    getSiteCodeOptions: builder.query({
      providesTags: ["SiteCodeOptions"],
      query: params => ({ url: "/api/warehouse/v1/site/code_options/", params }),
    }),
    getSiteById: builder.query({
      providesTags: (result, error, id) => [{ type: "SiteDetail", id }],
      query: id => `/api/warehouse/v1/site/${id}/`,
    }),
    createSite: builder.mutation({
      invalidatesTags: (result, error) =>
        error ? [] : ["SiteList", "SiteSelection", "SiteCodeOptions"],
      query: data => ({
        url: "/api/warehouse/v1/site/",
        method: "POST",
        body: data,
      }),
    }),
    patchSite: builder.mutation({
      invalidatesTags: (result, error, { id }) =>
        error
          ? []
          : [
              "SiteList",
              "SiteSelection",
              "SiteCodeOptions",
              { type: "SiteDetail", id },
              "WarehouseList",
              "WarehouseSelection",
              "WarehouseDetail",
            ],
      query: ({ data, id }) => ({
        url: `/api/warehouse/v1/site/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),
    getWorkCentersSelection: builder.query({
      query: (params = null) =>
        params
          ? `/api/warehouse/v1/work_center/selection/?${params}`
          : "/api/warehouse/v1/work_center/selection/",
      transformResponse: response => (Array.isArray(response) ? response : response?.results || []),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWorkCentersSelection(result.data)))
          .catch(error => {});
      },
      providesTags: ["WorkCenterSelection"],
    }),
    getWorkCenters: builder.query({
      query: (params = null) =>
        params ? `/api/warehouse/v1/work_center/?${params}` : "/api/warehouse/v1/work_center/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getWorkCenters(result.data))).catch(error => {});
      },
      providesTags: ["WorkCenterList"],
    }),
    getWorkCenterById: builder.query({
      query: id => `/api/warehouse/v1/work_center/${id}/`,
      providesTags: (result, error, id) => [{ type: "WorkCenterDetail", id }],
    }),
    createWorkCenter: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/work_center/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error) => (error ? [] : ["WorkCenterList", "WorkCenterSelection"]),
    }),
    patchWorkCenter: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api/warehouse/v1/work_center/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) =>
        error ? [] : ["WorkCenterList", "WorkCenterSelection", { type: "WorkCenterDetail", id }],
    }),
    getWorkCenterTypes: builder.query({
      query: (params = null) =>
        params
          ? `/api/warehouse/v1/work_center/types/?${params}`
          : "/api/warehouse/v1/work_center/types/",
      transformResponse: response => (Array.isArray(response) ? response : response?.results || []),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getWorkCenterTypes(result.data))).catch();
      },
    }),
    getWarehouseCosting: builder.query({
      query: (params = null) =>
        params
          ? `/api/warehouse/v1/warehouse_costing/?${params}`
          : "/api/warehouse/v1/warehouse_costing/",
      providesTags: ["WarehouseCostingList"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWarehouseCosting(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseCostingById: builder.query({
      query: id => ({
        url: `/api/warehouse/v1/warehouse_costing/${id}/`,
      }),
      providesTags: (result, error, id) => [{ type: "WarehouseCostingDetail", id: Number(id) }],
    }),
    getWarehouseCostingFields: builder.query({
      query: () => "/api_warehouse/warehouse_costing_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWarehouseCostingFields(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseCostingRange: builder.query({
      query: (params = null) =>
        params
          ? `/api_warehouse/warehouse_costing_range/?${params}`
          : "/api_warehouse/warehouse_costing_range/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWarehouseCostingRange(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseCostingSelection: builder.query({
      query: () => "/api_warehouse/warehouse_costing/selection/",
      providesTags: ["WarehouseCostingSelection"],
    }),
    getStandardCostingSelection: builder.query({
      query: params => ({ url: "/api_warehouse/standard_costing/selection/", params }),
    }),

    getWarehouseCostingRangeById: builder.query({
      query: id => ({
        url: `/api_warehouse/warehouse_costing_range/${id}/`,
      }),
    }),
    getWarehouseCostingRangeFields: builder.query({
      query: () => "/api_warehouse/warehouse_costing_range_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWarehouseCostingRangeFields(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseInventory: builder.query({
      query: () => "/api_warehouse/warehouse_inventory/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWarehouseInventory(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseLanded: builder.query({
      query: () => "/api_warehouse/warehouse_landed/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getWarehouseLanded(result.data))).catch(error => {});
      },
    }),
    syncStockSummary: builder.mutation({
      query: () => ({ url: "/api_warehouse/sync_inventory_level/", method: "POST", body: {} }),
    }),
    updateForecast: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_warehouse/forecast/${id}/`,
        method: "PUT",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateForecast(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleForecast: builder.mutation({
      query: data => ({
        url: "/api_warehouse/forecast/update_downloaded_forecasts/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleForecast(result.data.data)))
          .catch(error => {});
      },
    }),

    updateMultipleWarehouseCosting: builder.mutation({
      query: data => ({
        url: "/api_warehouse/warehouse_costing/update_downloaded_warehouse_costing/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleWarehouseCosting(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleWarehouseCostingRange: builder.mutation({
      query: data => ({
        url: "/api_warehouse/warehouse_costing_range/update_downloaded_warehouse_costing_range/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleWarehouseCostingRange(result.data.data)))
          .catch(error => {});
      },
    }),
    updateStockOnHand: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_warehouse/stock/${id}/update_stock/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateStockOnHand(result.data.data)))
          .catch(error => {});
      },
    }),
    updateStandardCosting: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api_warehouse/standard_costing/${id}/`,
        method: "PUT",
        body: data,
      }),
    }),

    updateStockLineAdjust: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_line/stock_adjust_update/",
        method: "post",
        body: data,
      }),
    }),
    updateStockZone: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api_warehouse/stock_zone/${id}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["StockZoneList", "StockZoneSelection", "StockZoneTypes"],
    }),

    updateStockLocation: builder.mutation({
      query: ({ data, id }) => ({
        url: `/api_warehouse/stock_location/${id}/`,
        method: "PUT",
        body: data,
      }),
    }),
    updateWarehouseCosting: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/warehouse/v1/warehouse_costing/${id}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) =>
        error
          ? []
          : [
              "WarehouseCostingList",
              "WarehouseCostingSelection",
              { type: "WarehouseCostingDetail", id: Number(id) },
              "ProductWarehouseCosting",
            ],
      onQueryStarted: async ({ id }, { dispatch, getState, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateWarehouseCosting(data));
          dispatch(
            apiSlice.util.updateQueryData("getWarehouseCostingById", Number(id), draft => {
              Object.assign(draft, data);
            }),
          );
          patchWarehouseCostingListCaches(dispatch, getState, data);
        } catch (error) {}
      },
    }),
    updateWarehouseCostingRange: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_warehouse/warehouse_costing_range/${id}/`,
        method: "PUT",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateWarehouseCostingRange(result.data)))
          .catch(error => {});
      },
    }),
    generateStockReplenishment: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_replenishment/generate/",
        method: "POST",
        body: data,
      }),
    }),
    stockMoveLocation: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_line/stock_move_location/",
        method: "post",
        body: data,
      }),
    }),
    stockReclassify: builder.mutation({
      query: data => ({
        url: "/api_warehouse/stock_line/stock_reclassify/",
        method: "post",
        body: data,
      }),
    }),
    releasePicklist: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/picklist/release/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Picklist"],
    }),
    cancelPicklist: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/picklist/cancel/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Picklist"],
    }),
    markReadyToPackPicklist: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/picklist/mark_ready_to_pack/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Picklist"],
    }),
    confirmPick: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/warehouse/v1/picklist/${id}/confirm_pick/`,
        method: "PATCH",
        body: data,
      }),
    }),
    getStockPackListSelection: builder.query({
      query: (params = null) =>
        params
          ? `/api/warehouse/v1/stock_pack/selection/?${params}`
          : "/api/warehouse/v1/stock_pack/selection/",
      providesTags: ["stockPack"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getStockPacksSelection(result.data)))
          .catch(error => {});
      },
    }),
    getStockPackList: builder.query({
      query: (params = null) =>
        params ? `/api/warehouse/v1/stock_pack/?${params}` : "/api/warehouse/v1/stock_pack/",
      providesTags: ["stockPack"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockPacks(result.data))).catch(error => {});
      },
    }),
    getStockPackById: builder.query({
      query: id => ({
        url: `/api/warehouse/v1/stock_pack/${id}/`,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getStockPack(result.data))).catch(() => {});
      },
    }),
    downloadStockPackPdf: builder.query({
      query: id => ({
        url: `/api/warehouse/v1/stock_pack/${id}/download_pdf/`,
        responseHandler: fileResponseHandler,
      }),
    }),
    getStockPackLines: builder.query({
      query: (params = {}) => ({
        url: "/api/warehouse/v1/stock_pack_line/",
        params,
      }),
    }),
    createStockPack: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/stock_pack/",
        method: "POST",
        body: data,
      }),
    }),
    confirmStockPack: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/stock_pack/confirm_pack/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["stockPack"],
    }),
    makeRfdStockPack: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/stock_pack/make_rfd/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["stockPack"],
    }),
    cancelStockPack: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/stock_pack/cancel/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["stockPack"],
    }),
    unpackStockPack: builder.mutation({
      query: data => ({
        url: "/api/warehouse/v1/stock_pack/unpack/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["stockPack"],
    }),
    updateStockPackLine: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/warehouse/v1/stock_pack_line/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useCreateForecastMutation,
  useCreateMultipleForecastsMutation,
  useCreateMultipleWarehouseCostingMutation,
  useCreateMultipleWarehouseCostingRangeMutation,
  useCreateStandardCostingMutation,
  useCreateStockLineMutation,
  useCreateStockLineAdjustMutation,
  useCreateStockLocationMutation,
  useCreateStockOnHandMutation,
  useCreateStockZoneMutation,
  useCreateWarehouseCostingMutation,
  useCreateWarehouseCostingRangeMutation,
  useDeleteForecastsMutation,
  useGetForecastsQuery,
  useGetForecastByIdQuery,
  useGetStandardCostsQuery,
  useGetStandardCostingByIdQuery,
  useGetStockFieldsQuery,
  useGetStockLinesQuery,
  useGetStockLineStatusQuery,
  useLazyGetStockLineStatusQuery,
  useGetStockLocationsQuery,
  useGetStockLocationByIdQuery,
  useGetStockLocationsSelectionQuery,
  useLazyGetStockLocationsSelectionQuery,
  useGetStockMethodsQuery,
  useGetStockOnHandQuery,
  useGetStockReplenishmentQuery,
  useGetStockStatusQuery,
  useGetStockZonesQuery,
  useLazyGetStockZonesSelectionQuery,
  useGetStockZonesSelectionQuery,
  useGetStockZoneByIdQuery,
  useGetWarehouseStockZoneTypesQuery,
  useLazyGetWarehouseStockZoneTypesQuery,
  useGetSitesQuery,
  useGetSiteByIdQuery,
  useGetSiteCodeOptionsQuery,
  useLazyGetSiteCodeOptionsQuery,
  useCreateSiteMutation,
  usePatchSiteMutation,
  useGetSitesSelectionQuery,
  useLazyGetSitesSelectionQuery,
  useGetWorkCentersQuery,
  useGetWorkCenterByIdQuery,
  useCreateWorkCenterMutation,
  usePatchWorkCenterMutation,
  useGetWorkCentersSelectionQuery,
  useLazyGetWorkCentersSelectionQuery,
  useGetWorkCenterTypesQuery,
  useLazyGetWorkCenterTypesQuery,
  useGetWarehouseCostingFieldsQuery,
  useGetWarehouseCostingQuery,
  useGetWarehouseCostingByIdQuery,
  useGetWarehouseCostingRangeFieldsQuery,
  useGetWarehouseCostingRangeQuery,
  useGetWarehouseCostingRangeByIdQuery,
  useGetWarehouseCostingSelectionQuery,
  useGetStandardCostingSelectionQuery,
  useLazyGetStandardCostingSelectionQuery,
  useGetWarehouseInventoryQuery,
  useGetWarehouseLandedQuery,
  useLazyGetDownloadedForecastQuery,
  useLazyGetDownloadedWarehouseCostingQuery,
  useLazyGetDownloadedWarehouseCostingRangeQuery,
  useSyncStockSummaryMutation,
  useUpdateForecastMutation,
  useUpdateMultipleForecastMutation,
  useUpdateMultipleWarehouseCostingMutation,
  useUpdateMultipleWarehouseCostingRangeMutation,
  useUpdateStandardCostingMutation,
  useUpdateStockLineAdjustMutation,
  useUpdateStockLocationMutation,
  useUpdateStockOnHandMutation,
  useLazyGetStockOnHandQuery,
  useUpdateStockZoneMutation,
  useUpdateWarehouseCostingMutation,
  useUpdateWarehouseCostingRangeMutation,
  useGenerateStockReplenishmentMutation,
  useGetStockReplenishmentByIdQuery,
  useLazyGetStockReplenishmentSelectionQuery,
  useConfirmStockReplenishmentMutation,
  useBulkConfirmReplenishmentMutation,
  useBulkRejectReplenishmentMutation,
  useGetPicklistsQuery,
  useGetPicklistByIdQuery,
  useGetPicklistLinesQuery,
  useStockMoveLocationMutation,
  useStockReclassifyMutation,
  useReleasePicklistMutation,
  useCancelPicklistMutation,
  useMarkReadyToPackPicklistMutation,
  useConfirmPickMutation,
  useLazyGetPicklistSelectionQuery,
  useGetStockPackListQuery,
  useLazyGetStockPackListSelectionQuery,
  useLazyGetStockPackListQuery,
  useGetStockPackByIdQuery,
  useGetStockPackLinesQuery,
  useCreateStockPackMutation,
  useConfirmStockPackMutation,
  useMakeRfdStockPackMutation,
  useCancelStockPackMutation,
  useUnpackStockPackMutation,
  useUpdateStockPackLineMutation,
  useLazyDownloadPicklistPdfQuery,
  useLazyDownloadStockPackPdfQuery,
} = warehouseApiSlice;
